export default __webpack_public_path__ + "static/media/singleBg.35318751.svg";